import { storeToRefs } from 'pinia';
import type { Address } from '~~/types/commercetools';

import { shippingDetailsStore } from '~/stores/shippingDetails';

import { useShipping } from '~/utils/ct';

export default function () {

  const store = shippingDetailsStore();
  const { shippingDetails } = storeToRefs(store);

  const {
    shipping: address,
  } = useShipping();

  const { defaultAddress } = useCheckout();

  store.setShippingDetails(address.value || defaultAddress);

  const setShippingDetailsMutation = (shippingDetails: Partial<Address>) => {

    const addressToSet = shippingDetails || address.value || defaultAddress;
    store.setShippingDetails(addressToSet);
  
  };

  return {
    ...store,
    shippingDetails,

    setShippingDetailsMutation,
  };

}